<!--
@component
Photos

See markup below.
-->

<script lang="ts">
  import PhotoCarousel from '$lib/components/common/PhotoCarousel/index.svelte';
  import { Spinner } from '@reuters-graphics/graphics-components';
  import '@splidejs/svelte-splide/css/splide-core.min.css';

  let { galleryUrl } = $props();

  let matchPhotos = $state<any[]>();

  const getMatchGallery = async (url: string | undefined) => {
    if (!url) return;
    try {
      const response = await fetch(url);
      const data = await response.json();
      // Require a url and altText
      matchPhotos = data.images
        .filter((d: any) => d.url && d.altText)
        .map((d: any) => ({
          src: d.url,
          altText: d.altText,
          credit: d.credit,
        }));
    } catch {
      matchPhotos = [];
    }
  };

  $effect(() => {
    // Capture current galleryUrl as a dependency
    const url = galleryUrl;
    getMatchGallery(url);
    const interval = setInterval(() => {
      getMatchGallery(url);
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  });
</script>

{#if matchPhotos && matchPhotos.length > 0}
  {#key matchPhotos.map((m) => m.src).join('')}
    <div>
      <PhotoCarousel
        class="my-0"
        photos={matchPhotos}
        maxHeight={700}
        width="wide"
        preloadImages={2}
      />
    </div>
  {/key}
{:else}
  <div class="placeholder">
    <Spinner />
  </div>
{/if}

<style lang="scss">
  @use '../../../styles/mixins' as mixins;

  div {
    margin-top: 2rem;
    margin-bottom: 4rem;
    &.placeholder {
      display: flex;
      justify-content: center;
    }
  }
</style>
